// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".reset_snIdLp .flexbox-fix_hzdV89:nth-child(n) {\n  width: 20px;\n}\n", "",{"version":3,"sources":["webpack://./src/lib/inputColor/index.less"],"names":[],"mappings":"AAAA;EAEI,WAAA;AAAJ","sourcesContent":[".reset {\n  .flexbox-fix:nth-child(n) {\n    width: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"reset": "reset_snIdLp",
	"flexbox-fix": "flexbox-fix_hzdV89"
};
export default ___CSS_LOADER_EXPORT___;
